import type { Editor, Element } from 'slate';
import { ReactEditor } from 'slate-react';
import type { CustomDescendant } from '../../types';

export function withCommonEditor(editor: Editor) {
  const { isInline } = editor;

  editor.isInline = (element: Element) => {
    return !element.children || isInline(element);
  };

  editor.focus = () => {
    ReactEditor?.focus?.(editor);
  };

  editor.clear = () => {
    editor.delete({
      at: {
        anchor: editor.start([]),
        focus: editor.end([]),
      },
    });
  };

  editor.setValue = (value: CustomDescendant[]) => {
    editor.clear();
    editor.insertFragment(value);
  };

  return editor;
}
